import { type ReactElement } from 'react';
import { useRouter } from '../router';
import { useT } from '../i18n/provider';
import { AuthLayout } from '../components/layout';
import { Button, AuthCard, Text } from '@vello/web-theme';

/** Shown when the inactivity/expiry watchdog forced a sign-out (S111). Shares the light auth card. */
export function SessionExpiredScreen(): ReactElement {
  const { navigate } = useRouter();
  const { t } = useT();
  return (
    <AuthLayout>
      <AuthCard>
        <h1 className="vello-auth-heading__title">{t('sessionExpired.title')}</h1>
        <Text as="p" tone="secondary">{t('sessionExpired.body')}</Text>
        <Button variant="primary" block onClick={() => navigate('login')}>
          {t('sessionExpired.action')}
        </Button>
      </AuthCard>
    </AuthLayout>
  );
}
